import { useRecoilValue } from "recoil";
import { userInfoAtom } from "../atom";

export const GetUserPermissions = () => {
    const userInfo = useRecoilValue(userInfoAtom);
    return userInfo?.permissions || [];
  };